module.exports = __webpack_public_path__ + "static/media/addVehicle.25aa7989.svg";